import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomSpinnerRequestHeader } from '@app/custom-service/spinner-interceptor.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
const BASE_PATH = environment.basePath;
@Injectable({
    providedIn: 'root',
})
export class HomeService {
    constructor(private httpClient: HttpClient) { }

    getUserByEmail(payload?: any, headers?: CustomSpinnerRequestHeader): Observable<any> {

        if (!headers) headers = new CustomSpinnerRequestHeader(true, { 'Content-Type': 'application/json' });

        return this.httpClient
            .post<any>(`${BASE_PATH}/bff/users/mainProfile`, payload, { headers: headers })
            .pipe(retry(1));
    }
}
